import { Popover, PopoverContent, PopoverTrigger } from "@/styles/ui/popover";
import { DimensionIcon } from "../dimension-icon";
import { TreeViewResponseItem } from "@/apis/preview/v2/types";
import { TagType } from "@/types/mapping";

interface TotalPopoverProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  item: TreeViewResponseItem;
}

export const TotalPopover = ({
  isOpen,
  setIsOpen,
  item,
}: TotalPopoverProps) => {
  return (
    <Popover open={isOpen}>
      <PopoverTrigger
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <DimensionIcon
          tagType={item.tagType as TagType}
          isSum={item.isSum}
          isExtendedTag={item.isExtendedTag}
        />
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="center"
        className="relative bg-neutral-900 rounded-[8px] px-[16px] py-[6px] shadow-[0px_10px_15px_-3px_rgba(0,0,0,0.1),0px_4px_6px_-4px_rgba(0,0,0,0.1)] border-0 h-[37px] w-[57px] "
      >
        <div className="absolute left-1/2 top-[-6px] transform -translate-x-1/2">
          <div className="w-[14.142px] h-[14.142px] rotate-45 bg-neutral-900"></div>
        </div>
        <span className="text-white text-[14px] font-medium leading-[1.429] whitespace-nowrap tracking-[0.203px]">
          합계
        </span>
      </PopoverContent>
    </Popover>
  );
};
